module.exports = __webpack_public_path__ + "img/EgyptTechWarElephantS_ua.9e760ef0.webp";